import { Tooltip } from "@mui/material";
import AuthService from "Lib/API/Auth";
import { ReactComponent as RecurringIcon } from "assets/icons/clockWise_refresh.svg";
import FormService from "Lib/API/Forms";
import { ReactComponent as Instagram } from "assets/icons/InstagramColorful.svg";
import { ReactComponent as Twitter } from "assets/icons/TwitterColorful.svg";
import { ReactComponent as Facebook } from "assets/icons/facebookColorful.svg";
import * as calculation from "helper/Calculate";
import { formatDate, setLocalizationMoment } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import { useMobileView } from "hook/mobileView/useMobileView";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import thousands from "thousands";
import {
  ContactInfo,
  ContactInfoDetails,
  ContactTitle,
  DashLine,
  Description,
  DescriptionText,
  FormCaption,
  FormLogin,
  FormName,
  FormTitle,
  Note,
  PayDetails,
  ReserveAction,
  ReserveButton,
  ReserveLoginButton,
  RightSideContent,
  RightSideWrappr,
  SocialIcons,
  TotalPay,
} from "./Theme";
import LoginModal from "../ReservationFormPage/PersonalDetailsCard/LoginModal";
import { toastr } from "react-redux-toastr";
import {
  getAccessTokenSilently,
  getAuthenticated,
  logout,
} from "utils/functions";
import { Fonts } from "theme/fontConfig";

export const RightSide = () => {
  const isAuthenticated = getAuthenticated();
  const currency = getCurrency();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
const { numberOfTickets } = useSelector((state) => state?.Forms);
  const { formOnlineData } = useSelector((state) => state?.Forms);
  const { isMobile } = useMobileView();

  const memberPortal = localStorage.getItem("memberPortal") === "true" || false;

  const hasMandatoryPrices = (formOnlineData?.formPricing?.prices || []).some(
    p => p.type === "onRegistration" || p.isRequired
  );
  const viewPayDeatils =
    (thousands(
      calculation.calculateTotalPaymentWithCVFee(
        formOnlineData,
        numberOfTickets,
        "form",
        isAuthenticated
      )
    ) !== "0.00" || hasMandatoryPrices) && !formOnlineData.freeForm;
  const params = useParams();
  const handleDifferanceDate = () => {
    const now = new Date();
    const end = new Date(formOnlineData?.formEndDate);

    const diffMs = end - now;

    if (diffMs <= 0) {
      return;
    }

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    if (diffHours < 24) {
      return diffHours === 1 ? (
        <span>{diffHours} Hour left!</span>
      ) : (
        <span>{diffHours} Hours left!</span>
      );
    }
    return diffDays === 1 ? (
      <span>{diffDays} Day left!</span>
    ) : (
      <span>{diffDays} Days left!</span>
    );
  };

  const [isShowMore, setIsShowMore] = useState(true);
  const toggleReadMore = () => setIsShowMore((show) => !show);
  const isExpiredClass = () => {
    const now = moment().tz("America/New_York");

    const start = moment(formOnlineData?.formStartDate).tz("America/New_York");
    const end = moment(formOnlineData?.formEndDate).tz("America/New_York");

    if (now.isBefore(start)) return true;

    if (now.isAfter(end)) return true;

    return false;
  };
  const isExpiredEvent = () => {
    const now = moment().tz("America/New_York");

    const start = moment(formOnlineData?.formStartDate).tz("America/New_York");
    const end = moment(formOnlineData?.formEndDate).tz("America/New_York");

    // Registration has not started yet
    if (now.isBefore(start)) return true;

    // Registration already ended
    if (now.isAfter(end)) return true;

    return false;
  };
  const getToken = async () => {
    let token = "";
    try {
      const subDomain = window.location.hostname.split(".")[0];
      const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
      await AuthService.generateToken(hostName).then((res) => {
        localStorage.setItem("formToken", res?.token);
        localStorage.setItem("logoImgForm", res?.logoImg);
        localStorage.setItem(
          "paymentMethodForms",
          JSON.stringify(res?.paymentMethodCreditCard)
        );
        localStorage.setItem(
          "achPaymentMethodForms",
          JSON.stringify(res?.paymentMethodAch)
        );
        localStorage.setItem("orgName", res?.orgName);
        localStorage.setItem("country", JSON.stringify(res?.country || {}));
        localStorage.setItem("memberPortal", res?.memberPortal || false);
        localStorage.setItem(
          "allowInstallments",
          res?.allowInstallments || false
        );

        setLocalizationMoment(res?.country?.local || "en");

        document.title = `${res?.orgName}`;
        token = res?.token;
      });
    } catch (error) {
      enqueueSnackbar(error?.formOnlineData?.message, {
        variant: "error",
      });
    }
    return token;
  };
  const handleReserveButton = () => {
    if (formOnlineData?.archived) {
      enqueueSnackbar("Form not available", { variant: "error" });
      return;
    }
    if (!formOnlineData?.allowNonMembers && !isAuthenticated) return;
    history.push(`/form/${params?.id}/reservation`);
  };
  useEffect(() => {
    if (!localStorage.getItem("formToken")) getToken();
  }, []);

  const displayRegistrationStartDate = () => {
    const showRegistrationStartDate =
      formOnlineData?.alwaysAvailable &&
      moment(formOnlineData?.formStartDate).isAfter(moment(), "day");
    return showRegistrationStartDate
      ? `submissions starts on ${formatDate({
          date: formOnlineData?.formStartDate,
          formatType: "defaultWithUTC",
        })}`
      : "";
  };

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
  }, []);

  const handleReserveLogin = () => {
    if (isAuthenticated) {
      handleReserveLogout();
      return;
    }
    setLoginModalOpen(true);
  };

  const handleReserveLogout = () => {
    localStorage.clear();
    window.location.href = `/form/${params?.id}`;
    toastr.success("Success", "Successfully Logged out!");
  };

  const reserveLoginButton = useMemo(
    () =>
      isAuthenticated
        ? "Logout"
        : formOnlineData?.allowNonMembers
        ? "Member? Log in here"
        : "Log in to sign up",
    [isAuthenticated, formOnlineData?.allowNonMembers]
  );

  const eventLogin = useMemo(() => (isAuthenticated ? "Logout" : "Login"), [
    isAuthenticated,
  ]);

  const sortedPrices = useMemo(() => {
    const prices = formOnlineData?.formPricing?.prices || [];
    return [...prices].sort((a, b) => {
      const getPriority = (p) => {
        if (p.type === "onRegistration") return 1;
        if (p.isRequired) return 2;
        return 3;
      };
      return getPriority(a) - getPriority(b);
    });
  }, [formOnlineData?.formPricing?.prices]);

  return (
    <>
    <LoginModal
      open={loginModalOpen}
      onClose={() => setLoginModalOpen(false)}
      onSuccess={() => {
        setLoginModalOpen(false);
        window.location.href = `/form/${params?.id}`;
      }}
    />
    <RightSideWrappr style={{zIndex:"10"}}>
      <RightSideContent>
        {memberPortal && (
          <FormLogin>
            <ReserveLoginButton onClick={handleReserveLogin}>
              {eventLogin}
            </ReserveLoginButton>
          </FormLogin>
        )}
        <FormTitle>
          <FormName>{formOnlineData?.formName}</FormName>
          <FormCaption>
            {displayRegistrationStartDate()}
            {!formOnlineData?.alwaysAvailable && (
              <span>
                Submissions End{" "}
                {formatDate({
                  date: formOnlineData?.formEndDate,
                  formatType: "defaultWithTimeEST",
                })}{" "}
                (EST)
              </span>
            )}
            {isExpiredEvent()
              ? ""
              : !formOnlineData?.alwaysAvailable && (
                  <div>{handleDifferanceDate()} </div>
                )}
            {!formOnlineData?.allowNonMembers && !isAuthenticated && (
              <div className="members-only-indicator">Members Only</div>
            )}
          </FormCaption>
        </FormTitle>

        {formOnlineData?.description &&
          formOnlineData.description.replace(/&lt;/g, "<").trim() !== "<p></p>" &&
          formOnlineData.description.replace(/&lt;/g, "<").trim() !== "<p></p>\n" &&
          formOnlineData.description.trim() !== "" && (
          <Description>
            <span>Description</span>
            <DescriptionText>
              <div className="drawer_description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: formOnlineData.description.replace(/&lt;/g, "<"),
                  }}
                ></p>
              </div>
            </DescriptionText>
          </Description>
        )}
        <ContactTitle>Contact Info</ContactTitle>
        <ContactInfo>
          <ContactInfoDetails>
            <span style={{ paddingRight: 10 }}>Name</span>
            {formOnlineData?.formDetails?.contactInfo?.firstName}{" "}
            {formOnlineData?.formDetails?.contactInfo?.lastName}
            {formOnlineData?.formDetails?.contactInfo?.showEmail && (
              <>
                <span
                  style={{ paddingRight: 10, paddingLeft: !isMobile && 20 }}
                >
                  Email
                </span>
                <p>{formOnlineData?.formDetails?.contactInfo?.email}</p>
              </>
            )}
          </ContactInfoDetails>
          <SocialIcons>
            {formOnlineData?.formDetails?.contactInfo?.facebook && (
              <a
                href={`${formOnlineData?.formDetails?.contactInfo?.facebook}`}
                rel="noreferrer"
              >
                <Facebook />
              </a>
            )}
            {formOnlineData?.formDetails?.contactInfo?.instagram && (
              <a
                href={`${formOnlineData?.formDetails?.contactInfo?.instagram}`}
                rel="noreferrer"
              >
                <Instagram />
              </a>
            )}
            {formOnlineData?.formDetails?.contactInfo?.twitter && (
              <a
                href={`${formOnlineData?.formDetails?.contactInfo?.twitter}`}
                rel="noreferrer"
              >
                <Twitter />
              </a>
            )}
          </SocialIcons>
        </ContactInfo>
        <DashLine />
        {!formOnlineData?.freeForm && (
          <PayDetails>
            {sortedPrices?.map((item, index) =>
              item?.type === "onRegistration" ? (
                viewPayDeatils && (
                  <>
                    <li key={index} style={{ textTransform: "capitalize" }}>
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                        {item?.title}
                        {item?.isRecurring && (
                          <Tooltip title="Monthly recurring" placement="top">
                            <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", padding: "7px 9px", backgroundColor: "rgba(37, 85, 239, 0.13)", borderRadius: "6px" }}>
                              <RecurringIcon width={9} height={9} />
                            </span>
                          </Tooltip>
                        )}
                      </span>
                      <span>
                        {item?.variant && item?.variantAmountRange
                          ? item.variantAmountRange.replaceAll("$", currency)
                          : numberFormat({ number: +item.amount, decimal: 2, style: "currency" })}
                      </span>
                    </li>
                    <Note>{item?.note}</Note>
                    <hr />
                  </>
                )
              ) : (
                <>
                  <li key={index} style={{ textTransform: "capitalize" }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                      {item?.title}
                      {item?.type === "optional" && !item?.isRequired && " (Optional)"}
                      {item?.isRecurring && (
                        <Tooltip title="Monthly recurring" placement="top">
                          <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", padding: "7px 9px", backgroundColor: "rgba(37, 85, 239, 0.13)", borderRadius: "6px" }}>
                            <RecurringIcon width={9} height={9} />
                          </span>
                        </Tooltip>
                      )}
                    </span>
                    <span>
                      {item?.amount || item?.minimumOpenAmount > 0
                        ? `${numberFormat({
                            number: item?.type === "openAmount" ? +item?.minimumOpenAmount || 0 : +item.amount,
                            decimal: 2,
                            style: "currency",
                          })}`
                        : item?.variantAmountRange
                        ? item?.variantAmountRange?.replaceAll("$", currency)
                        : `${numberFormat({
                            number: 0,
                            decimal: 2,
                            style: "currency",
                          })}`}
                    </span>
                  </li>
                  <Note>{item?.note}</Note>
                  <hr />
                </>
              )
            )}
            {viewPayDeatils &&
              formOnlineData?.formDiscount?.map((item, index) => (
                <>
                  <li
                    key={index}
                    className={`d-flex flex-column gap-2 ${
                      item?.forMemberOnly && !isAuthenticated
                        ? "opacity-50"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      {item?.discount_name}
                      {item?.discount_type === "date" &&
                        ` | ${formatDate({
                          date: item?.start_date,
                          formatType: "defaultWithUTC",
                        })} -
                                ${formatDate({
                                  date: item?.end_date,
                                  formatType: "defaultWithUTC",
                                })}`}
                      <span>
                        {item?.price_type === "percentage"
                          ? `${item?.value}%`
                          : `${numberFormat({
                              number: +item?.value,
                              decimal: 2,
                              style: "currency",
                            })}`}
                      </span>
                    </div>
                    {item?.forMemberOnly && !isAuthenticated && (
                      <span style={{ fontSize: Fonts.GeneralCaptionFont.fontSize }}>(Members Only)</span>
                    )}
                  </li>
                  <hr />
                </>
              ))}
            {viewPayDeatils && (
              <>
                <TotalPay>
                  TOTAL PAYMENT
                  <span>
                    {(() => {
                      const prices = formOnlineData?.formPricing?.prices || [];
                      const mandatoryTotal = prices.reduce((sum, p) => {
                        if (p.type !== "onRegistration" && !p.isRequired) return sum;
                        if (p.variant && p.variantInfo) {
                          const amounts = Object.values(p.variantInfo).map(v => v?.openAmount ? (v?.minimumOpenAmount || 0) : (v?.amount || 0));
                          return sum + Math.min(...amounts);
                        }
                        if (p.type === "openAmount") return sum + (p.minimumOpenAmount || 0);
                        return sum + (p.amount || 0);
                      }, 0) * numberOfTickets.length;
                      const discountedTotal = calculation.calculateDueDiscount(
                        mandatoryTotal,
                        formOnlineData?.formDiscount,
                        numberOfTickets,
                        isAuthenticated
                      )?.totalAfterDiscount;
                      return numberFormat({ number: Math.max(0, discountedTotal), decimal: 2, style: "currency" });
                    })()}
                  </span>
                </TotalPay>
                <hr />
              </>
            )}
          </PayDetails>
        )}

        <br />
      </RightSideContent>
      <ReserveAction>
        {memberPortal ? (
          <ReserveLoginButton onClick={handleReserveLogin}>
            {reserveLoginButton}
          </ReserveLoginButton>
        ) : (
          <div></div>
        )}
        <ReserveButton
          onClick={handleReserveButton}
          disabled={
            (!formOnlineData?.allowNonMembers && !isAuthenticated) ||
            isExpiredClass() ||
            isExpiredEvent() ||
            loading
          }
          disabledButton={
            (!formOnlineData?.allowNonMembers && !isAuthenticated) ||
            isExpiredClass() ||
            isExpiredEvent() ||
            loading
          }
        >
          {loading ? <PulseLoader color={"#fff"} size={"7px"} /> : formOnlineData?.buttonLabel || "Start"}
        </ReserveButton>
      </ReserveAction>
    </RightSideWrappr>
    </>
  );
};
